import { Box, Link, Typography } from "@mui/material";
import localize from "../../../common/localize";
import { BackForeColor } from "../../../components/common/BackForeColor";
import TotalValueItem from "./TotalValueItem";
import PaymentIcon from "./PaymentIcon";
import BillIcon from "./BillIcon";

const headerSx = {
  fontSize: "0.7rem",
  fontWeight: 600,
  color: "#5A6A7A",
  textTransform: "uppercase",
  letterSpacing: "0.04em",
};

const valueSx = {
  fontSize: "0.75rem",
  lineHeight: "1.1rem",
  color: "#1E293B",
};

function DataCell({ label, children, align = "left", flex = 1, minWidth }) {
  return (
    <Box sx={{ flex, minWidth: minWidth ?? 0, py: 0.25 }}>
      <Typography sx={headerSx}>{label}</Typography>
      <Box sx={{ mt: 0.25, textAlign: align }}>
        {typeof children === "string" ? (
          <Typography sx={{ ...valueSx, wordBreak: "break-word" }}>{children}</Typography>
        ) : (
          children
        )}
      </Box>
    </Box>
  );
}

export default function EventItem({ event }) {
  return (
    <Box
      sx={{
        border: "1px solid #E2E8F0",
        borderRadius: "6px",
        overflow: "hidden",
        "&:hover": { borderColor: "#CBD5E1", boxShadow: "0 1px 4px rgba(0,0,0,0.06)" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
          px: 1.5,
          py: 0.75,
          backgroundColor: "#F8FAFC",
          borderBottom: "1px solid #E2E8F0",
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Link
            color="primary"
            underline="hover"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              window.open(`/events/detail/${event.Id}`, "_blank");
            }}
            sx={{ fontSize: "0.8rem", fontWeight: 700, cursor: "pointer" }}
          >
            {event.Code}
          </Link>
          <BackForeColor
            backColor={event.OperationalStatus === 0 ? "white" : event.CurrentStatus?.BackgroundColor}
            foreColor={event.OperationalStatus === 0 ? "red" : event.CurrentStatus?.ForegroundColor}
            text={event.OperationalStatus === 0 ? localize.cancelled : event.CurrentStatus?.Name}
            styleName={event.OperationalStatus === 0 ? "cancelled_operational_status text-xs" : "text-xs"}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Typography sx={{ ...headerSx, textTransform: "none" }}>{localize.payed}</Typography>
            <PaymentIcon item={event} />
          </Box>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            <Typography sx={{ ...headerSx, textTransform: "none" }}>{localize.billed}</Typography>
            <BillIcon item={event} />
          </Box>
        </Box>
      </Box>

      <Box sx={{ px: 1.5, py: 0.5 }}>
        <BackForeColor
          styleName="text-xs w-full"
          backColor={event.EventType.BackgroundColor}
          foreColor={event.EventType.ForegroundColor}
          text={event.EventType.Name}
        />
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: { xs: 0.5, sm: 1 },
          px: 1.5,
          py: 1,
        }}
      >
        <DataCell label={localize.client}>
          {event.ReporterName ?? event.Client?.Name}
        </DataCell>
        <DataCell label={localize.address}>
          {event.Address ? `${event.Address} ${event.AddressComplement ?? ""}` : event.Client.Address}
        </DataCell>
        <DataCell label={localize.phone_number}>
          {event.ReporterPhoneNumber ?? event.Client?.PhoneNumber}
        </DataCell>
        <DataCell label={localize.assigned_to}>
          {event.PersonalAssigned
            ? `${event.PersonalAssigned.SurName} ${event.PersonalAssigned.LastName}`
            : localize.no_data}
        </DataCell>
        <DataCell label={localize.total_value}>
          <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
            <TotalValueItem notCentered hideEditPlaceholder customStyle="text-xs" item={event} />
          </Box>
        </DataCell>
        <DataCell label={localize.creation_date}>
          {new Date(event.CreationDate).toLocaleString(undefined, {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          })}
        </DataCell>
        {event.ProceedingInfo && (
          <DataCell label={localize.proceeding ?? "Proceso"}>
            {event.ProceedingInfo?.Name}
          </DataCell>
        )}
      </Box>
    </Box>
  );
}
